import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import associateServices from "../../services";
import {debounce} from "lodash";
import CasinoListItem from "../../containers/slots/item";
import {useLocation, useNavigate} from "react-router-dom";
import NoData from "../no-data";
import {useTranslation} from "react-i18next";
import ClassWatcher from "../../hooks/ClassWatcher";
import SvgIcon from "../svg-icon";
import StyleHelper from "../../helpers/styleHelper";
import SkeletonCasinoGroupGameItem from "../skeleton/casino-group-item";
import {useSelector} from "react-redux";
import store from "../../reducers/createReducers";
import {GLOBAL_CONSTANTS} from "../../constants/global-constants";
import stringHelper from "../../helpers/string-helper";
import SlimSelect from "slim-select";

const HeaderSearch = () => {
    const location = useLocation()
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const navigate = useNavigate()
    const {configuration} = useSelector(state => state.globalReducer)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [search, setSearch] = useState('')
    const [localItems, setLocalItems] = useState([])
    const [coloredData, setColoredData] = useState([])

    useEffect(() => {

        setData([])
        setLoading(false)
    }, [location?.pathname])
    useEffect(() => {
        setColoredData(data?.map(oo => ({
            ...oo,
            color: oo.color === 'random' ? StyleHelper.getRandomColor() : oo.color
        })))
    }, [data])
    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('recent-searches'));
        if (items) {
            setLocalItems(items);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('recent-searches', JSON.stringify(localItems));
    }, [localItems]);

    const handleClearLocalSearches = e => {
        e.preventDefault()
        e.stopPropagation()
        setLocalItems([])
    }
    const onClick = game => {
        if (!localItems?.includes(game?.name))
            setLocalItems(prevState => [game.name, ...prevState].slice(0, 10))

        navigate(stringHelper.getLocalizedPath(currentLanguage, `/casino/games/${game?.slug}`))
    }

    const uniqueById = (array) => {
        const seen = new Set();
        return array.filter(item => {
            if (seen.has(item.id)) {
                return false; // Skip if ID already exists
            } else {
                seen.add(item.id); // Add to seen and include in result
                return true;
            }
        });
    };

    const sendRequest = useCallback((name) => {
        setLoading(true)

        setData([])
        associateServices.searchGames({name}).then(res => {
            setData(uniqueById(res?.data || []))
            setLoading(false)
        })
    }, []);

    const debouncedSendRequest = useMemo(() => {
        return debounce(sendRequest, 500);
    }, [sendRequest]);

    const onChange = (e) => {
        setSearch(e.target.value);
        if (e?.target?.value?.length >= 3) {
            setData([])
            setLoading(true)
            debouncedSendRequest(e.target.value);
        }
    }

    const handleClickLatestSearch = value => {
        console.log('handleClickLatestSearch = ', value)
        setSearch(value);
        debouncedSendRequest(value);

        store.dispatch({
            type: GLOBAL_CONSTANTS.SET_HEADER_SEARCH_SHOWN,
            data: false
        })
        var multisearch = document.querySelector('.main__search-drop');
        multisearch?.classList?.remove('main__search-drop--active');

        navigate(stringHelper.getLocalizedPath(currentLanguage, `/`))
        // navigate('/')
    }

    useEffect(() => {
        if (document.querySelector('#multisearch')) {
            new SlimSelect({
                select: '#multisearch',
                settings: {
                    showSearch: false,
                }
            });
        }
    }, [])


    const inputRef = useRef(null)


    useEffect(() => {
        setColoredData(data?.map(oo => ({
            ...oo,
            color: oo.color === 'random' ? StyleHelper.getRandomColor() : oo.color
        })))
    }, [data]);

    const handleResponse = (res) => {
        setData(res?.data || []);
        setLoading(false);

        store.dispatch({
            type: GLOBAL_CONSTANTS.SET_HEADER_SEARCH_SHOWN,
            data: false
        })

        store.dispatch({
            type: GLOBAL_CONSTANTS.SET_DEFAULT_SEARCH_GAMES,
            data: res?.data || []
        })

    };


    function workOnClassAdd() {
        setLoading(true)
        setSearch('')
        setColoredData([])

        associateServices.getDashboardSlideGames({
            type: 'top'
        }).then(handleResponse); // Stop loading once the response is handled


        store.dispatch({
            type: GLOBAL_CONSTANTS.SET_HEADER_SEARCH_SHOWN,
            data: true
        })


        inputRef?.current?.focus()


    }

    function workOnClassRemove() {
        console.log('workOnClassRemove HEADER SEARCH ')

        store.dispatch({
            type: GLOBAL_CONSTANTS.SET_HEADER_SEARCH_SHOWN,
            data: false
        })

    }


    useEffect(() => {
        let targetNode = document.getElementById('drop-container')
        new ClassWatcher(targetNode, 'main__search-drop--active', workOnClassAdd, workOnClassRemove)
    }, [])


    return (

        <div className="main__search">
            <div className="main__search-drop" id={"drop-container"}>
                <div className="container pt-0">
                    <div className="row">
                        <div className="col-12">
                            <div className="multisearch">
                                <div className="multisearch__form">
                                    <input
                                        name="search"
                                        ref={inputRef}
                                        type="search"
                                        className="multisearch__input"

                                        placeholder={t('casino.search', 'Sarch')}
                                        value={search}
                                        onChange={onChange}
                                    />
                                    <button
                                        onClick={e => handleClickLatestSearch('')}
                                        className="multisearch__close" type="button">
                                        <SvgIcon id={'x'}/>
                                    </button>
                                </div>
                                <div className="multisearch__results">
                                    <div className="container-fluid">
                                        <div className="row gx-2 gx-sm-3 gx-md-4">
                                            {
                                                loading ? Array.from({length: 28}).map((_, index) => (
                                                    <div className="col-4 col-slot" key={index}>
                                                        <SkeletonCasinoGroupGameItem secondary={true}/>
                                                    </div>
                                                )) : data?.length <= 0 ?
                                                    <div className="col-12">
                                                        <NoData
                                                            desc={t('general.type-at-least-3-letters', 'Search requires at least 3 characters.')}/>
                                                    </div>
                                                    :
                                                    coloredData?.map((game, i) => <CasinoListItem
                                                        passive={game?.blacklist?.includes(configuration.country)}
                                                        onClick={onClick}
                                                        index={i} game={game} key={game.id}/>)
                                            }


                                        </div>
                                    </div>
                                </div>
                                {
                                    localItems?.length >= 1 &&
                                    <div className="multisearch__recent">
                                        <div className="multisearch__recent-head">
                                            <span>{t('search.title')}</span>
                                            <button
                                                onClick={handleClearLocalSearches}
                                                type="button">
                                                {t('search.clear')}({localItems?.length})
                                            </button>
                                        </div>
                                        <ul className="multisearch__tags">
                                            {
                                                localItems.map(game => (
                                                    <li onClick={e => handleClickLatestSearch(game)}
                                                        key={game}>
                                                        <span>{game}</span>
                                                        <button type="button">
                                                            <SvgIcon id={'x'}/>
                                                        </button>
                                                    </li>
                                                ))
                                            }

                                        </ul>
                                    </div>

                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default HeaderSearch
